import { AutomationRulesActionsType } from 'modules/automation-rules/actions/types/automation-rule-action-interface'
import { TimeType } from 'shared/components/date-picker/time-delay-picker/constants'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export enum ContactWorkflowDelayTypeEnum {
  Date = 'date',
  Fixed = 'fixed',
}

export type ContactWorkflowDelay = (
  | ContactWorkflowDelayDateInterface
  | ContactWorkflowDelayFixedInterface
) & { id: number }

interface ContactWorkflowDelayDateInterface {
  type: ContactWorkflowDelayTypeEnum.Date
  date: string
}

interface ContactWorkflowDelayFixedInterface {
  type: ContactWorkflowDelayTypeEnum.Fixed
  duration: number
  unit: TimeType
}

export type WorkflowAction = AutomationRulesActionsType & { id: number }

export interface ContactWorkflowInterface {
  workflowStep: {
    id: number
    action?: WorkflowAction
    workflow: {
      id: number
      name: string
    }
    delay?: ContactWorkflowDelay
  }
  isCompleted: boolean
  taskCreatedAt: string
  taskCompletedAt: string | undefined
}

export interface ContactWorkflowApiInterface
  extends DataWithPaginationInterface<ContactWorkflowInterface> {}
